import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "@/lib/data";

const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About", id: "about" },
  { to: "/services", label: "Services", id: "services" },
  { to: "/employers", label: "Employers", id: "employers" },
  { to: "/candidates", label: "Candidates", id: "candidates" },
  { to: "/jobs", label: "Jobs", id: "jobs" },
  { to: "/blog", label: "Insights", id: "insights" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const SERVICE_LINKS = ["IT Recruitment", "Non-IT Recruitment", "Leadership Hiring", "Volume Hiring", "End-to-End Recruitment"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/[0.06] bg-[#02060F]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Connecting Exceptional Talent with Exceptional Opportunities.
          </p>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            aria-label="Talentify on LinkedIn"
            className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 text-slate-400 transition-colors duration-300 hover:border-sky-400/50 hover:text-sky-400"
          >
            <Linkedin size={16} />
          </a>
        </div>
        <div>
          <h4 className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Navigate</h4>
          <ul className="space-y-3">
            {NAV.map((l) => (
              <li key={l.id}>
                <Link to={l.to} data-testid={`footer-nav-${l.id}`} className="text-sm text-slate-400 transition-colors duration-300 hover:text-sky-400">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Services</h4>
          <ul className="space-y-3">
            {SERVICE_LINKS.map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm text-slate-400 transition-colors duration-300 hover:text-sky-400">
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-2.5 transition-colors duration-300 hover:text-sky-400">
                <Mail size={14} className="text-sky-400" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone-link" className="flex items-center gap-2.5 transition-colors duration-300 hover:text-sky-400">
                <Phone size={14} className="text-sky-400" /> {CONTACT.phone}
              </a>
            </li>
            <li className="pt-2">
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-500 transition-colors duration-300 hover:text-sky-400">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="text-slate-500 transition-colors duration-300 hover:text-sky-400">
                Terms &amp; Conditions
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06]">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 sm:flex-row">
          <p className="text-xs text-slate-500">© 2026 Talentify. All Rights Reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-600">IT &amp; Non-IT Recruitment · PAN India</p>
        </div>
      </div>
    </footer>
  );
}
